import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PlayIcon from "../../../images/play_icon_purple.svg";
import React, { useMemo, useState } from "react";
import dayjs from "dayjs";

const PodcastCard = ({ handleSetActivePodcast, podcast }) => {
  const theme = useTheme();
  const mdAndUp = useMediaQuery(theme.breakpoints.up("md"));
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);

  const duration = useMemo(() => {
    const duration = dayjs.duration(podcast.duration_ms);
    const formattedTime = dayjs
      .utc(duration.as("milliseconds"))
      .format("mm:ss");

    return formattedTime;
  }, [podcast]);

  const date = useMemo(() => {
    const date = dayjs(podcast.release_date).format("MMM DD, YYYY");

    return date;
  }, [podcast]);

  return (
    <Stack
      sx={{
        padding: "25px 20px 25px",
        borderRadius: "10px",
        boxShadow: "-10px 11.1px 50px 0 rgba(188, 198, 210, 0.33)",
      }}
      direction="row"
      gap={3}
    >
      {mdAndUp && (
        <Stack
          sx={{
            width: "85px",
            height: "85px",
            borderRadius: "13px",
            overflow: "hidden",
            flexShrink: "0",
          }}
        >
          <Box
            component="img"
            src={podcast.images[1].url}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Stack>
      )}

      <Stack gap={"5px"} sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ color: "#a2aab5" }}>
          {podcast.name.split(" ")[0]}
        </Typography>

        <Typography
          sx={{
            color: theme.palette.primary.dark,
            fontWeight: "900",
            fontSize: { xs: "18px", md: "20px" },
            lineHeight: 1.2,
          }}
        >
          {podcast.name.split(" ").slice(1).join(" ")}
        </Typography>

        {mdAndUp && (
          <>
            {descriptionExpanded && (
              <Box
                dangerouslySetInnerHTML={{ __html: podcast.html_description }}
                sx={{
                  "& p": {
                    fontSize: "14px",
                    color: theme.palette.secondary.main,
                  },
                }}
              />
            )}

            {!descriptionExpanded && (
              <Typography
                variant="body2"
                sx={{
                  WebkitLineClamp: { xs: 1, md: "2" },
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  display: "-webkit-box",
                  color: theme.palette.secondary.main,
                }}
              >
                {podcast.description}
              </Typography>
            )}

            <Typography
              variant="caption"
              sx={{
                fontWeight: "700",
                cursor: "pointer",
                alignSelf: "start",
                "&:hover": {
                  fontWeight: "800",
                },
              }}
              onClick={() => {
                setDescriptionExpanded(!descriptionExpanded);
              }}
            >
              See {descriptionExpanded ? "less" : "more"}
            </Typography>
          </>
        )}

        {!mdAndUp && (
          <Stack sx={{ alignSelf: "stretch" }} direction="row">
            <Typography
              variant="caption"
              sx={{ color: "#a2aab5", mr: "auto", fontSize: "13px" }}
            >
              {date}
            </Typography>

            <Typography
              variant="caption"
              sx={{ color: "#a2aab5", fontSize: "13px" }}
            >
              {duration}
            </Typography>
          </Stack>
        )}

        <Button
          startIcon={
            <Box
              component="img"
              src={PlayIcon}
              sx={{ height: "20px", width: "20px" }}
            />
          }
          sx={{ alignSelf: "start" }}
          onClick={() => handleSetActivePodcast(podcast)}
          size="small"
        >
          Listen Now
        </Button>
      </Stack>

      {mdAndUp && (
        <Stack sx={{ alignItems: "end", flexShrink: 0 }}>
          <Typography
            variant="caption"
            sx={{ color: "#a2aab5", mb: "auto", fontSize: "13px" }}
          >
            {date}
          </Typography>

          <Typography
            variant="caption"
            sx={{ color: "#a2aab5", fontSize: "13px" }}
          >
            {duration}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default PodcastCard;
